import React, { useEffect } from 'react';
import { AppProviders } from '@/providers/AppProviders';
import StandaloneRoutes from '@/components/routing/StandaloneRoutes';
import { ReactContextGuard } from '@/components/ui/react-context-guard';
import { FullPageSpinner } from '@/components/ui/loading-spinner';
import { checkAndClearCacheIfNeeded, setupRuntimeChunkRecovery } from '@/utils/clearAppCache';
import { EmergencyAlarmOverlay } from '@/components/emergency/EmergencyAlarmOverlay';

const App: React.FC = () => {
  useEffect(() => {
    // Recover from stale service-worker cached builds that can cause chunk 404s
    setupRuntimeChunkRecovery();

    // Clear stale caches on app startup if version changed, then hard-reload once
    const RELOAD_KEY = 'ps_version_reload_done';
    checkAndClearCacheIfNeeded().then((cleared) => {
      if (cleared && sessionStorage.getItem(RELOAD_KEY) !== '1') {
        sessionStorage.setItem(RELOAD_KEY, '1');
        window.location.reload();
      }
    });
  }, []);

  return (
    <ReactContextGuard fallback={<FullPageSpinner message="Initializing application..." />}> 
      <AppProviders>
        <StandaloneRoutes />
        <EmergencyAlarmOverlay />
      </AppProviders>
    </ReactContextGuard>
  );
};

export default App;
